// extracted by mini-css-extract-plugin
module.exports = {"landingPageAccordionItem":"ui-z"};